import React from "react";
import { useAudioSystem } from "../context/AudioContext";
import { CATEGORY_STYLE, CATEGORIES } from "../lib/api";
import { Radio, Lock, ShieldAlert, Megaphone } from "lucide-react";

function categoryIcon(cat) {
  if (cat === "Emergency") return <ShieldAlert className="w-8 h-8" />;
  if (cat === "Safety") return <Lock className="w-8 h-8" />;
  if (cat === "General" || cat === "Events") return <Megaphone className="w-8 h-8" />;
  return <Radio className="w-8 h-8" />;
}

export default function Soundboard({ files, onTrigger }) {
  const { status } = useAudioSystem();
  const active = status === "priority";

  if (!files || files.length === 0) {
    return (
      <div data-testid="soundboard-empty" className="bg-[#18181B] border border-white/10 rounded-2xl p-10 text-center">
        <Radio className="w-12 h-12 text-[#3f3f46] mx-auto mb-3" />
        <p className="font-display font-black text-2xl text-white mb-1">NO PRIORITY AUDIO YET</p>
        <p className="text-[#71717A]">An administrator can add recordings in MANAGE AUDIO.</p>
      </div>
    );
  }

  const ordered = [...files].sort((a, b) => CATEGORIES.indexOf(a.category) - CATEGORIES.indexOf(b.category));

  return (
    <div>
      <h2 className="font-display font-black text-3xl tracking-tight text-white mb-4 flex items-center gap-3">
        <span className="text-[#FF3B30] neon-glow-red">PRIORITY AUDIO</span>
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
        {ordered.map((f) => {
          const s = CATEGORY_STYLE[f.category] || CATEGORY_STYLE.General;
          const big = f.category === "Emergency" || f.priority === "critical";
          return (
            <button
              key={f.id}
              data-testid={`soundboard-btn-${f.id}`}
              disabled={active}
              onClick={() => onTrigger(f)}
              className={`relative rounded-2xl p-5 flex flex-col justify-between text-left active:scale-95 transition-transform duration-75 disabled:opacity-40 ${big ? "h-40 md:col-span-1" : "h-32"}`}
              style={{ background: s.bg, color: s.text }}
            >
              <div className="flex items-center justify-between">
                {categoryIcon(f.category)}
                <span className="font-display font-bold text-xs tracking-widest opacity-80 uppercase">{s.label}</span>
              </div>
              <div>
                <div className="font-display font-black text-xl md:text-2xl leading-none tracking-tight uppercase">{f.name}</div>
                {f.is_critical && (
                  <span className="inline-flex items-center gap-1 mt-2 text-xs font-bold opacity-80">
                    <Lock className="w-3 h-3" /> PROTECTED
                  </span>
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
